import { navigation } from 'app/navigation/navigation';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { AuthService } from 'app/services/auth.service';
import { FuseNavigationService } from '../../../../../@fuse/components/navigation/navigation.service';
@Component({
    selector     : 'login',
    templateUrl  : './login.component.html',
    styleUrls    : ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class LoginComponent implements OnInit
{
    loginForm: FormGroup;
    public isLoging:boolean;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _auth:AuthService,
        private _nav:FuseNavigationService
        )
        {
        this.isLoging = false;
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.loginForm = this._formBuilder.group({
            user   : ['', [Validators.required]],
            password: ['', Validators.required]
        });
    }
    /* Funciones y handlers de los eventos en el dom para este componente */

    public async logIn(){
        this.isLoging = true;
        let data = this.loginForm.value;
        //Este servicio dispara un evento el cual está siendo escuchado desde app.component.html 
        let respuesta = await this._auth.login(data.user, data.password);
    }
}
